'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.beginningOfWeek;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/beginningOfWeek.js
// module id = 255
// module chunks = 0